// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RdUf","title":"styles_title__7Ldj-"};